<template>
	<div class='detail-box'>
		<div class="input-box">
				<span>商品名称：{{editData.pname}}</span>
		</div>
		<div class="input-box">
				<span>销售门店：{{editData.shopname}}</span>
		</div>
		<div class="input-box">
				<span>默认价格：{{defaultprice}}<span v-if="defaultprice">元</span></span>
		</div>
        <div class="input-box">
				<span>专用价格：</span>
                <el-input :disabled="isDisabled" :class="+defaultprice > +speprice ? 'isRed':''" class="name-input" size='mini' v-model="speprice" @input='priceInput' @change='priceChange'></el-input>
				<span>元</span>
				<span v-if="+defaultprice > +speprice" style="color:red;margin-left:20px">
					小于默认价格
				</span>
		</div>
        <div class="input-box">
				<span>有效日期：</span>
				<el-date-picker
					:disabled="isDisabled"
					style="width: 300px;"
					:unlink-panels='true'
					:clearable='false'
					size="mini"
					v-model="dateValue"
					type="datetimerange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					:default-time="['00:00:00', '23:59:59']"
					format='yyyy-MM-dd HH:mm'
					value-format='yyyy-MM-dd HH:mm:ss'>
				</el-date-picker>
		</div>
		<div slot="footer" class="dialog-footer" v-if='!isDisabled'>
			<el-button size='small' type='primary' class="fx-big-btn" plain @click="cancel">取消</el-button>
			<el-button size='small' type='primary' class="fx-big-btn" plain @click="save">保存</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'editModal',
	props: {
		editData: Object,
		isDisabled: Boolean
	},
	data () {
		return {
			dateValue: [],
			speprice: '',
			defaultprice: '',
			fxDataVerification: this.$fxUtils.fxDataVerification(),
			ruleForm: {}
		}
	},
	watch: {
		editData: {
			handler (val) {
				console.log(val)
				this.speprice = val.speprice === '' ? '' : this.$fxUtils.toFixedSHW(val.speprice, 2)
				this.defaultprice = val.defaultprice === '' ? '' : this.$fxUtils.toFixedSHW(val.defaultprice, 2)
				this.dateValue = [val.startdate + ':00', val.enddate + ':59']
				this.customerName = val.cusName
				this.ruleForm = {
					speprice: { speprice: this.speprice, pname: this.editData.pname, customerName: this.customerName },
					dateValue: { dateValue: this.dateValue, pname: this.editData.pname, customerName: this.customerName }
				}
				this.fxDataVerification.resetData(this.ruleForm)
			},
			immediate: true
		}
	},
	methods: {
		priceInput () {
			this.speprice = this.speprice.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.speprice = this.speprice.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.speprice = this.speprice.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.speprice = this.speprice.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			this.speprice = this.speprice.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
		},
		save () {
			if (this.speprice === '') {
				this.$message.error('请填写专用价格')
				return false
			}
			let params = {
				id: this.editData.id,
				beginDate: this.dateValue[0],
				endDate: this.dateValue[1],
				spePrice: this.speprice
			}
			// console.log(this.createLoggerParams())
			const logger = this.$fxLogger.createInfo('custom.custom-else.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/updateCustomerSpecialPrice`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.$emit('cancel', false)
					this.$message.success('保存成功')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		createLoggerParams () {
			const originData = this.fxDataVerification.getOriginData()
			const ruleFormClone = {
				speprice: { speprice: this.speprice, pname: this.editData.pname, customerName: this.customerName },
				dateValue: { dateValue: this.dateValue, pname: this.editData.pname, customerName: this.customerName }
			}
			return {
				pre: originData,
				cur: ruleFormClone
			}
		},
		priceChange () {
			console.log(this.speprice)
			this.speprice = this.speprice === '' ? '' : this.$fxUtils.toFixedSHW(this.speprice, 2)
			if (this.speprice === '' && this.editData.defaultprice !== '' && this.editData.defaultprice !== -1) {
				this.speprice = this.$fxUtils.toFixedSHW(this.editData.defaultprice)
			}
		},
		cancel () {
			this.$emit('cancel')
		}
	}
}
</script>

<style lang="stylus" scoped>
span{
	margin-top :10px
}
.detail-box{
    padding 10px 20px 10px 20px
    display: flex;
    height:220px;
    overflow-y:auto;
    text-align:left ;
	flex-direction: column
    .input-box{
			text-align :left
			width :100%;
			margin-bottom:10px
			.name-input {
				width: 150px;
				margin-right: 10px;
			}
			.select-box{
				width:180px;
				margin-right:10px;
			}
		}
}
.dialog-footer{
    margin-top:20px;
    text-align:center;
	.el-button{
		margin-right :15px
	}
}
.box{
    width:500px;
	height :80px;
	margin-top:-40px
}
.text{
    width:70px;
}
.text1{
    height: 60px;
    line-height:20px;
    overflow-y:auto;
	padding-left:30px
}
.img-list{
	display :inline-block;
    flex-wrap:wrap;
    margin-bottom:10px
}
.img-box{
    margin-top:10px;
    margin-left:25px;
    height: 120px;
    width:120px
}
.radio-box{
	flex-direction: column;
	width:200px;
    margin-top: 10px
	.el-radio{
		margin-left :30px;
		margin-bottom :10px;
		span{
			font-size :12px
		}
	}
}
.rule{
	width :400px;
	margin-left :30px;
	margin-bottom :10px;
}
.reason-input{
	width :300px
}
.logo{
	width:100px;
    position :relative;
    left: 410px;
    top: -110px;
    .logo-img{
        width :100px;
        height :50px
    }
}
.reason-box{
	padding-left :30px;
	display:block;
    height :40px;
    line-height :40px
}
.isRed >>> .el-input__inner{
		color:red
	}
</style>
